/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CropTrackerService = {

  /**
   * Save Crop Tracker Run
   * @param {*} payload 
   * @returns 
   */
  async save(payload) {
    const url = `api/AlmondcoCropTrackerRun/SaveCropTrackerRun`;
    return await ApiService.post(url, payload);
  },

  /**
   * Get MRP Header by MRPRun
   * @param {*} MRPRun 
   * @returns 
   */
  async getCropTrackerHeader(MRPRun) {
    const requestScreenData = {
      url: "api/AlmondcoCropTrackerRunHeader",
      filter: "MRPRun eq " + MRPRun,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },


};

export { CropTrackerService };
